import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { useTour } from '@orion.ui/orion';
import { ref } from 'vue';

export type TourTimeTicketReleaseNoteEmits = {};
export type TourTimeTicketReleaseNoteProps = {};

export default class TourTimeTicketReleaseNoteSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _tourTimeTicketReleaseNote = ref<OrionTour>();

	@Reactive private readonly state = {
		hasData: undefined as Undef<number>,
		isLaunched: false,
	};

	get hasData () { return this.state.hasData }

	constructor (
		private props: TourTimeTicketReleaseNoteProps,
		private emits: TourTimeTicketReleaseNoteEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();

		useTour('tourTimeTicketReleaseNote', this._tourTimeTicketReleaseNote.value);

		this.registerBusEvent('timeTicketWeeksLoaded', (data) => {
			this.state.hasData = data;
			this.state.isLaunched = true;
		});
	}

	firstIntegratedCircle () {
		const currentCardIntegratedDiv = document.querySelector(`
			.time-ticket-week-card--current
			> .orion-card__body
			> .week__circles
			> .time-ticket-week-circle:last-child`);

		return currentCardIntegratedDiv
			? currentCardIntegratedDiv
			: document.querySelector(`
				.time-ticket-week-card
				> .orion-card__body
				> .week__circles
				> .time-ticket-week-circle:last-child`);
	}

}
